/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Flow_Invitation_4Inputs */

const en_flow_invitation_4 = /** @type {(inputs: Flow_Invitation_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Back in Guestlist, the funnel moves: invited, booked, ordered.`)
};

/**
* | output |
* | --- |
* | "Back in Guestlist, the funnel moves: invited, booked, ordered." |
*
* @param {Flow_Invitation_4Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const flow_invitation_4 = /** @type {((inputs?: Flow_Invitation_4Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Flow_Invitation_4Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_flow_invitation_4(inputs)
});